import React from "react";
import { Chip, Tooltip } from "@mui/material";
// import { useTranslation } from "react-i18next";
import { getOrderState } from "../../utils/orderStates";

const ESIMStatusChip = ({ status }) => {
  // const { t } = useTranslation();
  const state = getOrderState(status?.toUpperCase() || "UNKNOWN");

  return (
    <Tooltip title={state.description}>
      <Chip
        label={state.label}
        color={state.color}
        variant="outlined"
        size="small"
      />
    </Tooltip>
  );
};

export default ESIMStatusChip;
